import { gql } from '@apollo/client';

export const GetCurrentCustomer = gql`
  query GetCurrentCustomer {
    customerService {
      getCurrentCustomer {
        customer {
          uuid
        }
      }
    }
  }
`;
